import { getZoneListRequest } from "../../data/zoneApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getZoneListUseCase() {
  const response = await getZoneListRequest();
  return getPayloadData(response);
}
